/* Nola R20.6 — confirmación de eliminar como MODAL centrado (sustituye la confirmación en línea).
   - Diálogo pequeño y centrado sobre el carrito, fondo suavemente oscurecido, colores de Nola.
   - Título «¿Quieres quitar este producto?» + nombre/variante. Principal oscuro «Conservar producto»,
     secundaria «Eliminar». Abre con la papelera y al bajar de 1→0. No modifica el carrito hasta confirmar.
   - Conservar / Escape / clic en el fondo cancelan y devuelven el foco al control que lo abrió.
   - Elimina por CLAVE de línea. Anti doble envío. Error con reintento. No cierra el drawer.
   - Restaura foco y scroll del carrito al cerrar. */
(function () {
  if (window.__nbRemoveConfirm) return; window.__nbRemoveConfirm = true;

  var modal = null, backdrop = null, opener = null, savedScroll = 0, scrollEl = null;

  function onCartPage() { return !!document.getElementById('main-cart-items'); }
  function rowOf(el) { return el.closest('.cart-item, tr.cart-item, [id^="CartDrawer-Item"], [id^="CartItem-"]'); }

  function sectionsFor() {
    var d = document.querySelector('cart-drawer');
    if (d && d.getSectionsToRender) return d.getSectionsToRender().map(function (s) { return s.id; });
    var ids = [];
    document.querySelectorAll('[id^="shopify-section"]').forEach(function (s) {
      if (/cart|CartDrawer|cart-icon-bubble|main-cart/i.test(s.id)) ids.push(s.id.replace('shopify-section-', ''));
    });
    if (ids.indexOf('cart-icon-bubble') < 0) ids.push('cart-icon-bubble');
    return ids;
  }
  function replaceSectionsManually(data) {
    if (!data || !data.sections) return false;
    var any = false;
    Object.keys(data.sections).forEach(function (id) {
      var el = document.getElementById('shopify-section-' + id) || document.getElementById(id);
      // cart-drawer / cart-icon-bubble render as the inner HTML of their host
      var host = el;
      if (!host) {
        if (id.indexOf('cart-drawer') > -1) host = document.querySelector('cart-drawer .drawer__inner') ? document.querySelector('cart-drawer') : null;
        if (id.indexOf('cart-icon-bubble') > -1) host = document.getElementById('cart-icon-bubble');
      }
      if (host && typeof data.sections[id] === 'string') {
        var t = document.createElement('div'); t.innerHTML = data.sections[id];
        var f = t.querySelector('#shopify-section-' + id) || t.firstElementChild;
        host.innerHTML = (f || t).innerHTML; any = true;
      }
    });
    return any;
  }
  // Actualiza la UI tras un cambio YA aplicado en el servidor. Devuelve siempre (nunca lanza).
  function updateUI(data) {
    if (onCartPage()) { window.location.reload(); return; }
    var d = document.querySelector('cart-drawer');
    try {
      if (d && typeof d.renderContents === 'function') { d.renderContents(data); return; }
    } catch (e) { /* cae a manual */ }
    if (!replaceSectionsManually(data)) { window.location.reload(); }
  }

  function close() {
    if (backdrop) { backdrop.remove(); backdrop = null; modal = null; }
    document.removeEventListener('keydown', onKey, true);
    if (opener && opener.focus) { try { opener.focus(); } catch (e) {} }  // devuelve el foco
    if (scrollEl != null) { try { scrollEl.scrollTop = savedScroll; } catch (e) {} } // restaura scroll del carrito
    opener = null;
  }
  function onKey(e) {
    if (!modal) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') { // focus trap
      var f = modal.querySelectorAll('button');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  // Firma canónica de propiedades de línea (orden de claves estable) para comparar sin ambigüedad.
  // Normaliza AMBAS formas a un objeto ordenado: Liquid `item.properties | json` da un ARRAY de pares
  // [["k","v"],...]; /cart.js da un OBJETO {"k":"v"}. CONSERVA TODAS las propiedades, incluidas las
  // internas (empiezan por "_"): que no se muestren no significa que no distingan la línea.
  function canonProps(v) {
    if (v == null) return '';
    var o = v;
    if (typeof v === 'string') {
      var s = v.trim();
      if (s === '' || s === '{}' || s === '[]' || s === 'null') return '';
      try { o = JSON.parse(s); } catch (e) { return s; }
    }
    if (o == null || typeof o !== 'object') return '';
    var pairs = {};
    if (Array.isArray(o)) {
      // array de pares [["k","v"], ...]
      o.forEach(function (p) { if (Array.isArray(p) && p.length >= 1) pairs[String(p[0])] = p.length > 1 ? p[1] : ''; });
    } else {
      Object.keys(o).forEach(function (k) { pairs[k] = o[k]; });
    }
    var keys = Object.keys(pairs).sort();  // TODAS las claves, incluidas las internas "_"
    if (!keys.length) return '';
    var out = {};
    keys.forEach(function (k) { out[k] = pairs[k]; });
    return JSON.stringify(out);
  }
  function samePlan(a, b) { return String(a == null ? '' : a) === String(b == null ? '' : b); }

  function doRemove(key, variantId, delBtn, props, plan) {
    if (delBtn.disabled) return; delBtn.disabled = true;
    var keepBtn = modal.querySelector('[data-nb-keep]'); if (keepBtn) keepBtn.disabled = true;
    var errEl = modal.querySelector('.nb-rmm__err'); if (errEl) errEl.hidden = true;
    var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var wantProps = canonProps(props);
    // La clave de línea puede cambiar al recalcular descuentos → resolvemos la ACTUAL desde /cart.js.
    // 1) clave exacta (identificador canónico). 2) si no existe, variant_id + propiedades + selling plan
    //    (nunca solo variant_id). Si tras ese filtro sigue habiendo VARIAS líneas → ambigüedad:
    //    refrescamos el carrito y volvemos a pedir confirmación en vez de adivinar.
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = null, i, it;
        for (i = 0; i < cart.items.length; i++) { if (cart.items[i].key === key) { line = cart.items[i]; break; } }
        if (!line && variantId) {
          var cand = [];
          for (i = 0; i < cart.items.length; i++) {
            it = cart.items[i];
            if (String(it.variant_id) !== String(variantId)) continue;
            if (canonProps(it.properties) !== wantProps) continue;
            if (!samePlan(it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.id : '', plan)) continue;
            cand.push(it);
          }
          if (cand.length === 1) { line = cand[0]; }
          else if (cand.length > 1) { return { ambiguous: true }; } // no adivinar
        }
        if (!line) { opener = null; close(); window.location.reload(); return null; } // ya no está: cierra y refresca
        return fetch(base + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0, sections: sectionsFor(), sections_url: window.location.pathname })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
    }).then(function (res) {
      if (res == null) return;
      if (res.ambiguous) {                       // varias líneas indistinguibles → refresca y repite
        var em = modal && modal.querySelector('.nb-rmm__err');
        if (em) { em.textContent = 'No se pudo identificar la línea con seguridad. Hemos actualizado el carrito; vuelve a intentarlo.'; em.hidden = false; }
        delBtn.disabled = false; if (keepBtn) keepBtn.disabled = false;
        fetch(base + '?sections=' + sectionsFor().join(','), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); }).then(function (j) { updateUI(j); }).catch(function () {});
        return;
      }
      if (!res.ok || res.j.status) { throw new Error('change-failed'); } // cambio NO aplicado → error real
      opener = null;            // el control ya no existe tras eliminar
      close();                  // cierra el modal (el cambio ya está aplicado)
      updateUI(res.j);          // refresca la UI (nunca lanza)
    }).catch(function () {
      delBtn.disabled = false; if (keepBtn) keepBtn.disabled = false;
      if (errEl) { errEl.textContent = 'No se pudo eliminar. Inténtalo de nuevo.'; errEl.hidden = false; }
    });
  }

  function openModal(key, variantId, label, opnr, props, plan) {
    if (modal) return;
    opener = opnr;
    scrollEl = document.querySelector('cart-drawer .cart-drawer__form') || document.querySelector('cart-drawer .drawer__inner');
    savedScroll = scrollEl ? scrollEl.scrollTop : 0;
    backdrop = document.createElement('div');
    backdrop.className = 'nb-rmm-backdrop';
    backdrop.innerHTML =
      '<div class="nb-rmm" role="dialog" aria-modal="true" aria-labelledby="nbRmmTitle">' +
        '<h2 class="nb-rmm__title" id="nbRmmTitle">¿Quieres quitar este producto?</h2>' +
        '<p class="nb-rmm__item">' + (label || '') + '</p>' +
        '<div class="nb-rmm__actions">' +
          '<button type="button" class="nb-rmm__keep" data-nb-keep>Conservar producto</button>' +
          '<button type="button" class="nb-rmm__del" data-nb-del>Eliminar</button>' +
        '</div>' +
        '<p class="nb-rmm__err" role="alert" hidden>No se pudo eliminar. Inténtalo de nuevo.</p>' +
      '</div>';
    document.body.appendChild(backdrop);
    modal = backdrop.querySelector('.nb-rmm');
    var keep = modal.querySelector('[data-nb-keep]');
    var del = modal.querySelector('[data-nb-del]');
    keep.focus();
    keep.addEventListener('click', close);
    del.addEventListener('click', function () { doRemove(key, variantId, del, props, plan); });
    backdrop.addEventListener('click', function (e) { if (e.target === backdrop) close(); }); // clic en el fondo cancela
    document.addEventListener('keydown', onKey, true);
  }

  // 1) Papelera / botón «×» de eliminar
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-remove-button[data-nb-key]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    openModal(btn.getAttribute('data-nb-key'), btn.getAttribute('data-variant-id'), btn.getAttribute('data-nb-label'), btn, btn.getAttribute('data-nb-props'), btn.getAttribute('data-nb-plan'));
  }, true);

  // 2) Bajar la cantidad de 1 a 0 → misma confirmación
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('.quantity__button[name="minus"], button[name="minus"]');
    if (!minus) return;
    if ((minus.getAttribute('name') || '').toLowerCase() !== 'minus') return;
    var wrap = minus.closest('quantity-input, .quantity, .cart-item__quantity');
    var input = wrap ? wrap.querySelector('input.quantity__input, input[type="number"]') : null;
    if (!input) return;
    if (parseInt(input.value, 10) === 1) {
      e.preventDefault(); e.stopPropagation();
      var r = rowOf(minus);
      var rm = r ? r.querySelector('.cart-remove-button[data-nb-key]') : null;
      if (rm) openModal(rm.getAttribute('data-nb-key'), rm.getAttribute('data-variant-id'), rm.getAttribute('data-nb-label'), minus, rm.getAttribute('data-nb-props'), rm.getAttribute('data-nb-plan'));
    }
  }, true);
})();
